const FAQ_BASE_TITLE = 'Întrebări frecvente'

const ROMANIAN_PREPOSITIONS = [
  'despre',
  'pentru',
  'cu',
  'la',
  'prin',
  'de',
  'pe',
  'în',
  'din',
  'spre',
  'către',
]

export function buildFaqSectionTitle(title?: string | null): string {
  const trimmed = (title ?? '').trim()
  if (!trimmed) return FAQ_BASE_TITLE

  const firstSpace = trimmed.search(/\s/)
  const firstWord = firstSpace === -1 ? trimmed : trimmed.slice(0, firstSpace)
  const rest = firstSpace === -1 ? '' : trimmed.slice(firstSpace)

  if (ROMANIAN_PREPOSITIONS.includes(firstWord.toLowerCase())) {
    return `${FAQ_BASE_TITLE} ${firstWord.toLowerCase()}${rest}`
  }

  return `${FAQ_BASE_TITLE} despre ${trimmed}`
}
